import React, { Component, PropTypes } from 'react';
import R from 'ramda';
import FolderFilters from './folder-filters';
import { connect } from 'react-redux';
import LockIcon from 'material-ui/svg-icons/action/lock';
import { openUpgradeFrom as openUpgradeFromAction } from '../../../../stores/ui/components/upgrade/upgrade-actions';
import { TextField, RaisedButton, Checkbox } from 'material-ui';
import RedDot from '../../../tc-ui/redDot';
import { statuses as rcStatuses } from '../../dummy-account/update-rate-conversion-status';

const propTypes = {
  isSingleLocation: PropTypes.bool,
  companyType: PropTypes.string,
  searchParams: PropTypes.shape({
    companySearchInput: PropTypes.string,
    locationSearchInput: PropTypes.string,
    searchInput: PropTypes.string,
    searchCategory: PropTypes.string,
    stateFilterForBuyer: PropTypes.array,
    stateFilterForSupplier: PropTypes.array,
    sentFilter: PropTypes.array,
    readUnreadFilter: PropTypes.array,
    otherSideRead: PropTypes.array,
    contractTypeFilter: PropTypes.array,
    openAdvanceSearch: PropTypes.bool,
    newActivity: PropTypes.bool,
    showRateContainers: PropTypes.bool,
    showArchivedDeleted: PropTypes.bool,
    searchingAllYears: PropTypes.bool,
  }),
  updateProps: PropTypes.func,
  search: PropTypes.func,
  folders: PropTypes.array,
  billingPlan: PropTypes.string,
  openUpgradeFrom: PropTypes.func,
  userId: PropTypes.string,
};

class PreciseSearch extends Component {
  constructor(props) {
    super(props);
    this.state = props.searchParams;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { isSingleLocation, searchParams, companyType, search, folders, openUpgradeFrom } = this.props;
    const {
      stateFilterForBuyer,
      stateFilterForSupplier,
      contractTypeFilter,
      rateConversionStatusFilter,
      readUnreadFilter,
      companySearchInput,
      locationSearchInput,
      otherSideRead,
    } = this.state;
    const stateFilter = companyType === 'Supplier' ? stateFilterForSupplier : stateFilterForBuyer;
    // const onlySentSelected = (!stateFilter.length || !(stateFilter.length === 1 && stateFilter[0] === 'sent'));
    const describeAllStateFilters = [
      companyType === 'Supplier' ? { state: 'request' } : null,
      { state: 'sent', subStates: ['bounced', 'delivered', 'opened'] },
      companyType === 'Supplier' ? null : { state: 'received' },
      { state: 'accepted' },
      { state: 'rejected' },
      { state: 'loading' },
      { state: 'loaded' },
    ].filter(x => x);
    const isSupplier = (companyType === 'Supplier');
    const readUnreadFilterDoesNotApply = (() => {
      if (isSupplier) {
        return !R.contains('request', stateFilter);
      }
      return stateFilter.length === 1 && stateFilter[0] === 'sent';
    })();
    return (
      <div style={{ paddingLeft: '24px', display: 'flex', position: 'relative', top: '-8px' }}>
        <div style={{ width: '33%', display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex' }}>
            <small style={{ width: '120px', color: 'rgba(0, 0, 0, 0.74)', position: 'relative', top: '20px' }}>Folder:</small>
            <FolderFilters
              companyType={companyType}
              searchParams={this.state}
              onChange={newParams => this.setState(newParams)}
              folders={folders}
              underlineStyle={{ borderTopColor: '#00bcd4', margin: 0 }}
              style={{ width: '150px' }}
              labelStyle={{ textAlign: 'left', paddingLeft: 0, paddingRight: '12px', fontSize: '12px' }}
              iconStyle={{ fill: '#00bcd4', width: '30px' }}
            />
          </div>
          <div style={{ display: 'flex' }}>
            <small style={{ width: '120px', color: 'rgba(0, 0, 0, 0.74)', position: 'relative', top: '20px' }}>Company/Email:</small>
            <TextField
              id="companySearchInput"
              value={companySearchInput}
              style={{ width: '150px', fontSize: '12px' }}
              underlineStyle={{ borderBottomColor: '#00bcd4' }}
              onKeyDown={e => {
                if (e.keyCode === 13) search(R.merge(this.state, { searchingAllYears: searchParams.searchingAllYears }));
              }}
              onChange={(_, value) => this.setState({ companySearchInput: value })}
            />
          </div>
          {
            isSingleLocation ? <span/> : (
              <div style={{ display: 'flex' }}>
                <small style={{ width: '120px', color: 'rgba(0, 0, 0, 0.74)', position: 'relative', top: '20px' }}>Property Name:</small>
                <TextField
                  id="locationSearchInput"
                  value={locationSearchInput}
                  style={{ width: '150px', fontSize: '12px' }}
                  underlineStyle={{ borderBottomColor: '#00bcd4' }}
                  onKeyDown={e => {
                    if (e.keyCode === 13) search(R.merge(this.state, { searchingAllYears: searchParams.searchingAllYears }));
                  }}
                  onChange={(_, value) => this.setState({ locationSearchInput: value })}
                />
              </div>
            )
          }
          {
            companyType === 'Contractor' && (
              <div>
                <Checkbox
                  label="Show Archived or Deleted"
                  checked={this.state.showArchivedDeleted}
                  labelStyle={{ fontSize: '12px' }}
                  style={{ width: '220px' }}
                  onCheck={() => this.setState({ showArchivedDeleted: !this.state.showArchivedDeleted })}
                />
                <Checkbox
                  label="Show Workspaces"
                  checked={this.state.showRateContainers}
                  labelStyle={{ fontSize: '12px' }}
                  style={{ width: '250px' }}
                  onCheck={() => this.setState({ showRateContainers: !this.state.showRateContainers })}
                />
              </div>
            )
          }
        </div>
        <div style={{ width: '30%', padding: '16px 32px' }}>
          <small style={{ width: '120px', color: 'rgba(0, 0, 0, 0.74)', display: 'block', marginBottom: '8px' }}>Statuses:</small>
          <div>
            {
              describeAllStateFilters.map((obj, i) => {
                const onCheck = (_, inputChecked) => {
                  if (obj.subStates) {
                    this.setState({ [`${obj.state}Filter`]: inputChecked ? obj.subStates : [] });
                  }
                  this.setState({
                    [`stateFilterFor${isSupplier ? 'Supplier' : 'Buyer'}`]: inputChecked ? R.append(obj.state, stateFilter)
                      : stateFilter.filter(str => str !== obj.state),
                  });
                };
                const subStateFilter = this.state[`${obj.state}Filter`] || [];
                const checked = R.contains(obj.state, stateFilter);
                if (!obj.subStates) {
                  return (<Checkbox
                    checked={checked}
                    key={i}
                    labelStyle={{ fontSize: '12px', width: '90px' }}
                    label={obj.state}
                    onCheck={onCheck}
                  />);
                }
                return (
                  <div key={i} >
                    <Checkbox
                      checked={checked}
                      labelStyle={{ fontSize: '12px', width: '90px' }}
                      label={obj.state}
                      onCheck={onCheck}
                    />
                    <div
                      style={{ marginLeft: '16px', display: checked ? 'block' : 'none' }}
                      className={this.props.billingPlan === 'basic' ? 'hint--top' : ''}
                      aria-label={this.props.billingPlan === 'basic' ? `Upgrade to filter all sent status` : ''}
                    >
                      {
                        obj.subStates.map((subState, subI) => {
                          const onCheckSubstate = (_, inputChecked) => {
                            this.setState({
                              [`${obj.state}Filter`]: inputChecked ? R.append(subState, subStateFilter) : subStateFilter.filter(str => str !== subState),
                            });
                          };
                          const subStateChecked = R.contains(subState, subStateFilter);
                          if (this.props.billingPlan === 'basic') {
                            return (
                              <Checkbox
                                key={subI}
                                checked={subStateChecked}
                                checkedIcon={<LockIcon style={{ fill: '#FFD700' }} />}
                                labelStyle={{ fontSize: '12px' }}
                                label={subState}
                                onCheck={() => openUpgradeFrom('contractListSentFilters')}
                              />
                            );
                          }
                          return <Checkbox checked={subStateChecked} key={subI} labelStyle={{ fontSize: '12px' }} label={subState} onCheck={onCheckSubstate} />;
                        })
                      }
                    </div>
                  </div>
                );
              })
            }
          </div>
          {
            companyType === 'Contractor' && (
              <div style={{ paddingTop: '16px', marginTop: '16px', borderTop: '1px solid #e0e0e0' }}>
                <small style={{ width: '220px', color: 'rgba(0, 0, 0, 0.74)', display: 'block', marginBottom: '8px' }}>TC Rate Conversion Statuses:</small>
                <div>
                  {
                    rcStatuses.map(status => (
                      <Checkbox
                        key={status}
                        labelStyle={{ fontSize: '12px' }}
                        label={status}
                        checked={R.contains(status, rateConversionStatusFilter)}
                        onCheck={(_, inputChecked) => this.setState({
                          rateConversionStatusFilter: inputChecked
                            ? R.append(status, rateConversionStatusFilter)
                            : rateConversionStatusFilter.filter(str => str !== status),
                        })}
                      />
                    ))
                  }
                </div>
              </div>
            )
          }
        </div>
        <div style={{ width: '37%', paddingTop: '16px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          {
            companyType === 'Contractor' && (
              <div style={{ marginBottom: '16px', borderBottom: '1px solid #e0e0e0', paddingBottom: '16px' }}>
                <small style={{ color: readUnreadFilterDoesNotApply ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.74)', display: 'block', marginBottom: '8px' }}>Contract Type (received rates):</small>
                <div>
                  <Checkbox
                    labelStyle={{ fontSize: '12px' }}
                    label="TourConnect Contract Format - New"
                    disabled={readUnreadFilterDoesNotApply}
                    checked={R.contains('tc-new', contractTypeFilter)}
                    onCheck={(_, inputChecked) => this.setState({ contractTypeFilter: inputChecked ? R.append('tc-new', contractTypeFilter) : contractTypeFilter.filter(str => str !== 'tc-new') })}
                  />
                  <Checkbox
                    labelStyle={{ fontSize: '12px' }}
                    label="TourConnect Contract Format - Updates"
                    disabled={readUnreadFilterDoesNotApply}
                    checked={R.contains('tc-updates', contractTypeFilter)}
                    onCheck={(_, inputChecked) => this.setState({ contractTypeFilter: inputChecked ? R.append('tc-updates', contractTypeFilter) : contractTypeFilter.filter(str => str !== 'tc-updates') })}
                  />
                  <Checkbox
                    labelStyle={{ fontSize: '12px' }}
                    label="External Contract Format - with Files"
                    disabled={readUnreadFilterDoesNotApply}
                    checked={R.contains('external-files', contractTypeFilter)}
                    onCheck={(_, inputChecked) => this.setState({ contractTypeFilter: inputChecked ? R.append('external-files', contractTypeFilter) : contractTypeFilter.filter(str => str !== 'external-files') })}
                  />
                  <Checkbox
                    labelStyle={{ fontSize: '12px' }}
                    label="External Contract Format - without Files"
                    disabled={readUnreadFilterDoesNotApply}
                    checked={R.contains('external-nofiles', contractTypeFilter)}
                    onCheck={(_, inputChecked) => this.setState({ contractTypeFilter: inputChecked ? R.append('external-nofiles', contractTypeFilter) : contractTypeFilter.filter(str => str !== 'external-nofiles') })}
                  />
                </div>
              </div>
            )
          }
          <div style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '16px', marginBottom: '16px' }}>
            <small style={{ color: readUnreadFilterDoesNotApply ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.74)', display: 'block', marginBottom: '8px' }}>
              Read/Unread:
            </small>
            <div>
              <Checkbox
                labelStyle={{ fontSize: '12px' }}
                disabled={readUnreadFilterDoesNotApply}
                label={`Read ${(isSupplier) ? 'Requests' : 'Received Rates'}`}
                checked={R.contains('read', readUnreadFilter)}
                onCheck={(_, inputChecked) => this.setState({ readUnreadFilter: inputChecked ? R.append('read', readUnreadFilter) : readUnreadFilter.filter(str => str !== 'read') })}
              />
              <Checkbox
                labelStyle={{ fontSize: '12px', fontWeight: 'bold' }}
                disabled={readUnreadFilterDoesNotApply}
                label={`Unread ${(isSupplier) ? 'Requests' : 'Received Rates'}`}
                checked={R.contains('unread', readUnreadFilter)}
                onCheck={(_, inputChecked) => this.setState({ readUnreadFilter: inputChecked ? R.append('unread', readUnreadFilter) : readUnreadFilter.filter(str => str !== 'unread') })}
              />
              <Checkbox
                labelStyle={{ fontSize: '12px' }}
                label="Viewed / Downloaded Contracts"
                checked={R.contains('viewedDownloaded', otherSideRead || [])}
                onCheck={(_, inputChecked) => this.setState({ otherSideRead: inputChecked ? R.append('viewedDownloaded', otherSideRead) : otherSideRead.filter(str => str !== 'viewedDownloaded') })}
              />
              <Checkbox
                labelStyle={{ fontSize: '12px' }}
                label="Not Viewed / Downloaded Contracts"
                checked={R.contains('notViewedDownloaded', otherSideRead || [])}
                onCheck={(_, inputChecked) => this.setState({ otherSideRead: inputChecked ? R.append('notViewedDownloaded', otherSideRead) : otherSideRead.filter(str => str !== 'notViewedDownloaded') })}
              />
            </div>
          </div>
          <div>
            <Checkbox
              labelStyle={{ fontSize: '12px' }}
              label={<span style={{ display: 'flex', alignItems: 'center' }}>New Activity <RedDot style={{ left: '3px', top: '0px' }} /></span>}
              checked={this.state.newActivity}
              onCheck={(_, inputChecked) => this.setState({ newActivity: inputChecked })}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px', width: '100%', flexDirection: 'row-reverse' }}>
            <RaisedButton
              label="Search All Periods"
              labelStyle={{ top: '4px' }}
              style={{ minWidth: '185px', width: '185px', marginLeft: '8px', height: '33px' }}
              secondary
              onTouchTap={() => search(R.merge(this.state, { searchingAllYears: true }))}
            />
          </div>
        </div>
      </div>
    );
  }
}
PreciseSearch.propTypes = propTypes;
const mapStateToProps = ({ user, contracting }) => ({
  companyType: user.getIn(['user', 'type']),
  userId: user.get('id'),
  billingPlan: user.get('billingPlan'),
  folders: contracting.contractList.get('folders').toJS(),
  isSingleLocation: user.getIn(['user', 'company', 'oneOrMultiProperties']),
});

export default connect(mapStateToProps, { openUpgradeFrom: openUpgradeFromAction })(PreciseSearch);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/top-bar/precise-search.jsx